import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * The single class-composition helper. Merges conditional classes (clsx) and
 * resolves Tailwind conflicts (tailwind-merge) so later classes win.
 *
 * Used everywhere a className is composed. Primitives are the only place that
 * should pass token utilities (bg-canvas, text-ink-soft, …) through it.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
